import { useQuery } from 'react-query';

export default (sessionToken, sessionId) => {
  const { data, isLoading, isSuccess } = useQuery(
    ['GET', `/apis/v2/direct_video_session_tokens/conversation`, { headers: { 'Adracare-Session-Token': sessionToken, 'Adracare-Session-Id': sessionId } }],
    {
      enabled: !!sessionToken && !!sessionId,
    },
  );
  return { data: data?.data?.attributes?.messages || [], isLoading, isSuccess };
};
